import { gql } from "@apollo/client";

const AddUserProjectMutation = gql`
  mutation addUserProjectMutation($userId: UUID!, $projectName: String!) {
    createUserProject(
      input: { userProject: { userAppId: $userId, projectName: $projectName } }
    ) {
      userProject {
        id
        projectName
      }
    }
  }
`;

const hash = "07b95ac0d678755d8323befe518fdc8e50d1f3a7ade3ad2d7ee025d20847c721";

export { AddUserProjectMutation, hash };
